<template>
	<div class="container">
		<div class="content" v-html="content">
			
		</div>
		<mainFooter/>
	</div>
</template>

<script>
	import mainFooter from '../../../../src/basic/components/layout/mainFooter.vue';
	export default {
		components: {
			mainFooter,
		},
		data() {
			return {
				content: '',
			}
		},
		mounted() {
			this.getAgreement();
		},
		methods: {
			getAgreement() {
				this.$load();
				this.$get('app-agreement/3', {}, true).then(res => {
					this.content = res.data.content;
				}).catch(err => {
					this.$warning(err);
				})
			},
		},
	}
</script>

<style lang="scss" scoped>  
	.container {
		width: 100%;
		background-color: #fff;
		.content {
			min-height: calc(100vh - 300px);
			width: 68%;
			margin: 0 auto;
		}
	}
</style>